import { useEffect } from "react";
import {
  TextField,
  Grid,
  InputAdornment,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setDialog,
  resetForm,
  ExternalRevenue,
} from "../../../app/slices/externalRevenueSlice";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { HiOutlineArrowTrendingUp, HiOutlineBanknotes } from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../components/FormDialog";

const ExternalRevenueForm = () => {
  const _ExternalRevenue = useSelector((state) => state.externalRevenue.externalRevenue);
  const _SearchBody = useSelector((state) => state.externalRevenue.searchBody);

  const { control, reset, watch, register, handleSubmit, setValue } = useForm({
    defaultValues: _ExternalRevenue.form,
  });

  const onSubmit = (data) => {
    dispatch(ExternalRevenue.create({
      amount: data.amount,
      note: data.note,
    }, _SearchBody));
  };

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
  }, []);

  const dispatch = useDispatch();

  const handleDialog = () => {
    dispatch(setDialog());
  };

  return (
    <FormDialog
      open={_ExternalRevenue.dialog}
      onClose={() => {
        handleDialog();
      }}
      icon={<HiOutlineArrowTrendingUp />}
      title={"إضافة ربح خارجي"}
      subtitle="أدخل المبلغ والملاحظة لإضافته"
      onSubmit={handleSubmit(onSubmit)}
    >
      <SectionCard icon={<HiOutlineBanknotes />} title="معلومات الربح">
        <Grid item xs={12}>
          <Controller
            name='amount'
            control={control}
            render={({ field: { onChange, ...renderProps } }) => {
              return (
                <NumericFormat
                  customInput={TextField}
                  label='المبلغ'
                  size="small"
                  fullWidth
                  InputProps={{
                    startAdornment: <InputAdornment position="start">IQD</InputAdornment>,
                  }}
                  {...renderProps}
                  onValueChange={target => {
                    onChange();
                    setValue('amount', target.floatValue);
                  }}
                  isNumericString
                  thousandSeparator
                />
              );
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name="note"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="الملاحظة"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default ExternalRevenueForm;
